import gracias from "@/config/constants/gracias";

describe("gracias", () => {
  it("should have the correct properties", () => {
    expect(gracias).toHaveProperty("ok");
    expect(gracias.ok).toHaveProperty("img");
    expect(gracias.ok).toHaveProperty("offer");
    expect(gracias.ok).toHaveProperty("nextSteps");
    expect(gracias.ok).toHaveProperty("offerEmprendedor");
    expect(gracias.ok).toHaveProperty("offerSubtitulo");
  });

  it("should have the correct values", () => {
    expect(gracias.ok.img).toBe("asset4.png");
    expect(gracias.ok.offer).toBe(
      "recibimos tus datos, un representate de BBVA se pondrá en contacto con vos en los próximos días."
    );
    expect(gracias.ok.nextSteps).toEqual([
      "<strong>Un representante de BBVA se comunicará con vos</strong> para asesorarte y brindarte información respecto a la apertura de cuentas para Comercios."
    ]);
    expect(gracias.ok.offerEmprendedor).toBe(
      "recibimos tus datos. <br> Un representante de BBVA se contactará con vos en las próximas 72 horas."
    );
    expect(gracias.ok.offerSubtitulo).toBe(
      "Queremos acompañarte con los productos que mejor se adapten a tus necesidades."
    );
  });
});
